import { adminAPI } from '@/lib/api';
import { toast } from '@/components/ui/sonner';

// Warn before saving a window change that would drop paid (not-yet-ordered) orders out of the window.
export const confirmWindowImpact = async (supplierId, open, close) => {
  let data;
  try {
    data = (await adminAPI.windowImpact(supplierId, { window_open_date: open, window_close_date: close })).data || {};
  } catch {
    toast.error('Could not check for affected orders');
    return window.confirm('Could not check whether paid orders are affected by this window change.\n\nSave the new window anyway?');
  }
  const { count = 0, orders = [] } = data;
  if (!count) return true;
  const list = orders.slice(0, 10).map((o) => `• ${o.order_number}${o.customer ? ` (${o.customer})` : ''}`).join('\n');
  const more = count > 10 ? `\n…and ${count - 10} more` : '';
  return window.confirm(
    `${count} paid order(s) not yet on a PO were placed during the time this change removes from the window:\n${list}${more}\n\n`
    + 'After saving they will no longer be picked up by this window\'s PO and will show in the out-of-window alert.\n\nSave the new window anyway?'
  );
};
